import { connect } from 'react-redux'
import Shared from './shared'
import { fetchSharedPresentations } from '../../../../../stores/shared-presentations/shared-presentations.actions'
import {
  getFetchPresentationsRequest,
  getPresentations
} from '../../../../../stores/shared-presentations/shared-presentations.selectors'

const mapStateToProps = state => {
  const fetchPresentationsRequest = getFetchPresentationsRequest(state)
  const presentations = getPresentations(state)
  return {
    noPresentations: presentations && !presentations.result.length,
    pending: !presentations || fetchPresentationsRequest.pending
  }
}

const mapDispatchToProps = dispatch => ({
  onMount: () => dispatch(fetchSharedPresentations())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Shared)
